/** Convert decoded samples to display greyscale, applying the modality LUT exactly once. */
export function previewWindowPixels(
  pixels: ArrayLike<number>,
  rows: number,
  columns: number,
  window: { windowWidth: number; windowCenter: number },
  rescale: { slope: number; intercept: number } = { slope: 1, intercept: 0 },
): Uint8ClampedArray {
  if (
    rows <= 0 ||
    columns <= 0 ||
    pixels.length !== rows * columns ||
    !Number.isFinite(window.windowWidth) ||
    window.windowWidth <= 0
  ) {
    throw new Error("Preview frame has invalid dimensions, pixels, or window");
  }
  const rgba = new Uint8ClampedArray(rows * columns * 4);
  const lower = window.windowCenter - window.windowWidth / 2;
  for (let index = 0; index < pixels.length; index++) {
    const hu = pixels[index] * rescale.slope + rescale.intercept;
    if (!Number.isFinite(hu)) throw new Error("Preview frame contains invalid pixel values");
    const intensity = Math.max(0, Math.min(255, ((hu - lower) / window.windowWidth) * 255));
    rgba[index * 4] = rgba[index * 4 + 1] = rgba[index * 4 + 2] = intensity;
    rgba[index * 4 + 3] = 255;
  }
  return rgba;
}
